import { render, staticRenderFns } from "./block-table-cols.vue?vue&type=template&id=59886480"
import script from "./block-table-cols.vue?vue&type=script&lang=js"
export * from "./block-table-cols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports